/* global $ */

import { gup } from '../helpers/params';

// BSD sourcing
const source = gup('utm_source') || gup('source');

// adds sourcing field to BSD forms based on any source in the url
$(document).ready(() => {
  if (source) {
    $.$body.find('form').each(function() {
      const $form = $(this);
      if ($form.find('[name="source"]').length) {
        $form.find('[name="source"]').val(source);
      } else {
        $('<input/>', {
          type: 'hidden',
          name: 'source',
          value: source,
        }).appendTo($form);
      }
    });
  }
});

function register($form) {
  $('.mailchimp-form__submit-container input')
    .prop('disabled', true)
    .val('Sending...');
  setTimeout(() => {
    $('.mailchimp-form__form-section')
      .css({ alignItems: 'center', marginTop: '0' })
      .html($('.mailchimp-form__thanks_msg').html());
    // Almost finished... We need to confirm your
    // email address. To complete the subscription process,
    // please click the link in the email we just sent you.
  }, 1000);
  $.ajax({
    type: $form.attr('method'),
    url: $form.attr('action'),
    data: $form.serialize(),
    cache: false,
    cors: true,
    dataType: 'jsonp',
    contentType: 'application/json; charset=utf-8',
  });
}

$.$body.on('submit', '#mc-embedded-subscribe-form', (event) => {
  event.preventDefault();
  console.log(event);
  register($(event.currentTarget));
});
